import { jsx as _jsx } from "react/jsx-runtime";
export const InitialCommentInputContainer = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "bottom-0 z-1 w-full border-t border-t-grey-5 bg-grey-1 p-5",
        children: children
    });
};
